<template>
  <div>
    <b-button variant="warning" class="dashboard-upcoming-expense-payment-button"  @click="modalShow = !modalShow">
      <i class="pe pe-money pe-dashboard-upcoming-expense-payment" aria-hidden="true"/>
    </b-button>
    <b-modal v-model="modalShow"
             :title="expenseLabel + ' - Payment'"
             hide-footer
             no-fade
             @hidden="
               SET_MODAL_CLOSED()
               resetForm()"
             @shown="SET_MODAL_OPEN()"
    >
      <div v-if="error" class="alert alert-danger">{{ error }}</div>
      <div v-if="message" class="alert alert-success">{{ message }}</div>
      <div class="form-group row">
        <label for="paymentAmount" class="col-md-4 col-form-label text-md-right">Amount</label>
        <div class="col-md-6">
          <b-input-group :append="expenseCurrency | uppercase">
            <input id="paymentAmount"
                   ref="paymentAmount"
                   v-model="form.amount"
                   :class="{ 'is-invalid': errors.paymentAmount }"
                   autofocus
                   type="number"
                   pattern="[0-9]*"
                   class="form-control"
                   @keyup.enter="submitPayment()"
            >
          </b-input-group>
          <span v-if="errors.paymentAmount" class="invalid-feedback d-block">
            <div v-for="(error, index) in errors.paymentAmount" :key="index"><strong>{{ error }}</strong></div>
          </span>
        </div>
      </div>
      <div class="form-group row mb-0">
        <div class="col-12 text-center">
          <button type="submit" class="btn btn-primary" @click.prevent="submitPayment()">
            <span v-if="this.$loading.isLoading('saving-upcoming-expense-payment')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Submit
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'UpcomingExpensesPayment',
  props: {
    ledgerId: {
      required: true
    },
    expenseId: {
      required: true
    },
    expenseLabel: {
      required: true
    },
    expenseEstimate: {
      required: true
    },
    expenseCurrency: {
      required: true
    }
  },
  data () {
    return {
      modalShow: false,
      form: {
        amount: this.expenseEstimate
      },
      message: '',
      error: '',
      errors: {}
    }
  },
  computed: {
    ...mapState({
      state: state => state
    })
  },
  methods: {
    ...mapMutations([
      'SET_MODAL_OPEN',
      'SET_MODAL_CLOSED'
    ]),
    ...mapActions([
      'createPayment',
      'getUnpaidExpenses',
      'getUpcomingExpenses'
    ]),
    resetForm () {
      this.error = ''
      this.errors = {}
      this.message = ''
    },
    submitPayment () {
      this.$loading.startLoading('saving-upcoming-expense-payment')
      this.errors = {}
      this.createPayment({ 'ledgerId': this.ledgerId, 'expenseId': this.expenseId, 'payment': this.form })
        .then((data) => {
          this.error = ''
          this.form.amount = ''
          this.form.description = ''
          this.message = data.message
          this.getUnpaidExpenses()
          this.getUpcomingExpenses()
          this.$loading.endLoading('saving-upcoming-expense-payment')
        })
        .catch((data) => {
          this.message = ''
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('saving-upcoming-expense-payment')
        })
    }
  }
}
</script>

<style>
  .dashboard-upcoming-expense-payment-button {
    position: absolute;
    right: -15px;
    top: 25px;
    background: none!important;
  }
  .pe-dashboard-upcoming-expense-payment {
    width: 29px !important;
    height:20px !important;
  }
</style>
